<script>
import UsefulInfoCollapsible from '@/components/UsefulInfoCollapsible'
import ViewTitle from '@/components/ViewTitle'
import ViewDescription from '@/components/ViewDescription'
import DOMUtils from '@/utils/DOMUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import UsefulInfoServices from '@/services/usefulInfo'

export default
{
    name: 'useful-info',

    created ()
    {
        UsefulInfoServices.fetchInfos(EnvironmentUtils.cityId).then(infos  =>
        {
            this.$store.commit('usefulInfos/updateInfoList', infos)
        })
    },

    render () 
    {
        return (
            <div id='useful-info-view'>
                <div class='header'>
                    <view-title>Informations utiles</view-title>
                    <view-description>Vous pouvez cliquer sur les tuiles ci-dessous pour afficher du contenu supplémentaire.</view-description>
                </div>
                <div class='info-list'>
                {
                    this.infos.map(info => !info.isUncreated && <useful-info-collapsible info={info} />)
                }
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        infos ()
        {
            return this.$store.state.usefulInfos.infoList
        }
    },

    mounted ()
    {
    },

    beforeRouteEnter (to, from, next)
    {
        // Tiles popping animation.
        next(vm =>
        {
            if (LocalStorageUtils.useIntensiveAnimations)
            {
                let tilesContainer = vm.$root.$el;
                let tiles = tilesContainer.querySelectorAll('.collapsible')
                
                let delay = 0;

                tiles.forEach(tile =>
                {
                    tile.style.opacity = 0
                    setTimeout(() =>
                    {
                        tile.style.opacity = 1
                        DOMUtils.animateCSS(tile, 'zoomIn', '0.2s')
                    }, delay)

                    delay += 100;
                })
            }
        })
    },

    methods:
    {
    },

    components:
    {
        UsefulInfoCollapsible,
        ViewTitle,
        ViewDescription
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#useful-info-view
{
    margin-top: calc(var(--theme-status-bar-height) + 6vw);
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);
    margin-left: 3vw;
    margin-right: 3vw;

    .OnTablet({
        margin-left: 8vw;
        margin-right: 8vw;
    });

    .OnDesktop({
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        padding-left: 12vw;
        padding-right: 12vw;
        margin-top: 4vw;
    });

    > .header
    {
        margin-left: 3vw;

        .OnDesktop({ margin-left: 1vw; });
    }

    > .info-list
    {
        > .useful-info-collapsible
        {
            margin-top: 15px;

            .phone-number-actions
            {
                .button
                {
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/UsefulInfo.vue